// extracted by mini-css-extract-plugin
export default {"root":"styles_root__vSMxe","disabled":"styles_disabled__w749s"};